import React from 'react';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import PropTypes from 'prop-types';
import useHomeContext from 'Context/HomeContext';
import { AuthenticationContainer } from './AuthenticationContainer';

// Get a new version of home whenever this component mounts so that it's refreshed when looking at auth
export const AuthenticationHomeContainer = ({ url }) => {
  const { refreshHomeResource } = useHomeContext();
  const [initializing, setInitializing] = React.useState(true);

  const initialize = async () => {
    await refreshHomeResource({ skipFetchIfRecentlyUpdated: true });
    setInitializing(false);
  };

  React.useEffect(() => {
    initialize();
  }, []);

  return (
    <FullScreenDataContainer
      component={AuthenticationContainer}
      componentProps={{ url }}
      loading={initializing}
    />
  );
};

AuthenticationHomeContainer.propTypes = {
  url: PropTypes.string.isRequired,
};
